import * as React from 'react';
import api from '../../../services/api';
import {
  Paper,
  Button,
  Box,
  FormControl,
  Stack,
  DialogContentText,
  Divider,
  Popover,
  Typography,
  Link
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useStoreActions } from 'easy-peasy';
import {
  TextField,
  Select,
  Checkbox,
  NoRowsOverlay,
  FloatField,
  IntegerField
} from '../../../components';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { estados } from './estadosBrasileiros';
import DialogoAreasProtegidasEImpactadas from './DialogoAreasProtegidasEImpactadas';
import {
  DataGrid,
  GridActionsCellItem
} from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';

const DadosGerais = ({ ano, watchEmpresaId }) => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);

  const [firstPopoverAnchor, setFirstPopoverAnchor] = React.useState(null);
  const [secondPopoverAnchor, setSecondPopoverAnchor] = React.useState(null);
  const [thirdPopoverAnchor, setThirdPopoverAnchor] = React.useState(null);
  const [fourthPopoverAnchor, setFourthPopoverAnchor] = React.useState(null);
  const [fifthPopoverAnchor, setFifthPopoverAnchor] = React.useState(null);
  const [sixthPopoverAnchor, setSixthPopoverAnchor] = React.useState(null);
  const [seventhPopoverAnchor, setSeventhPopoverAnchor] = React.useState(null);
  const [eighthPopoverAnchor, setEighthPopoverAnchor] = React.useState(null);
  const [ninthPopoverAnchor, setNinthPopoverAnchor] = React.useState(null);
  const [tenthPopoverAnchor, setTenthPopoverAnchor] = React.useState(null);
  const [eleventhPopoverAnchor, setEleventhPopoverAnchor] = React.useState(null);
  const [twelfthPopoverAnchor, setTwelfthPopoverAnchor] = React.useState(null);
  const [thirteenthPopoverAnchor, setThirteenthPopoverAnchor] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [dadosAreas, setDadosAreas] = React.useState(null);
  const [openDialogo, setOpenDialogo] = React.useState(false);

  const estadosObj = estados.reduce((map, item) => {
    map[item.id] = item.label;
    return map;
  }, {});

  const handleFirstClick = event => {
    setFirstPopoverAnchor(event.currentTarget);
  };

  const handleSecondClick = event => {
    setSecondPopoverAnchor(event.currentTarget);
  };

  const handleThirdClick = event => {
    setThirdPopoverAnchor(event.currentTarget);
  };

  const handleFourthClick = event => {
    setFourthPopoverAnchor(event.currentTarget);
  };
  const handleFifthClick = event => {
    setFifthPopoverAnchor(event.currentTarget);
  };

  const handleSixthClick = event => {
    setSixthPopoverAnchor(event.currentTarget);
  };
  const handleSeventhClick = event => {
    setSeventhPopoverAnchor(event.currentTarget);
  };
  const handleEighthClick = event => {
    setEighthPopoverAnchor(event.currentTarget);
  };
  const handleNinthClick = event => {
    setNinthPopoverAnchor(event.currentTarget);
  };
  const handleTenthClick = event => {
    setTenthPopoverAnchor(event.currentTarget);
  };
  const handleEleventhClick = event => {
    setEleventhPopoverAnchor(event.currentTarget);
  };
  const handleTwelfthClick = event => {
    setTwelfthPopoverAnchor(event.currentTarget);
  };
  const handleThirteenthClick = event => {
    setThirteenthPopoverAnchor(event.currentTarget);
  };
  const handleCloseFirstClick = event => {
    setFirstPopoverAnchor(null);
  };

  const handleCloseSecondClick = event => {
    setSecondPopoverAnchor(null);
  };

  const handleCloseThirdClick = event => {
    setThirdPopoverAnchor(null);
  };

  const handleCloseFourthClick = event => {
    setFourthPopoverAnchor(null);
  };
  const handleCloseFifthClick = event => {
    setFifthPopoverAnchor(null);
  };

  const handleCloseSixthClick = event => {
    setSixthPopoverAnchor(null);
  };
  const handleCloseSeventhClick = event => {
    setSeventhPopoverAnchor(null);
  };
  const handleCloseEighthClick = event => {
    setEighthPopoverAnchor(null);
  };
  const handleCloseNinthClick = event => {
    setNinthPopoverAnchor(null);
  };
  const handleCloseTenthClick = event => {
    setTenthPopoverAnchor(null);
  };
  const handleCloseEleventhClick = event => {
    setEleventhPopoverAnchor(null);
  };
  const handleCloseTwelfthClick = event => {
    setTwelfthPopoverAnchor(null);
  }
  const handleCloseThirteenthClick = event => {
    setThirteenthPopoverAnchor(null);
  }

  const opcoesBooleanas = [
    {
      id: 1,
      label: 'SIM'
    },
    {
      id: 2,
      label: 'NÃO'
    }
  ];

  const schema = yup
    .object({
      areaDoacaoEstadoHa: yup
        .number()
        .nullable()
        .nanable()
        .label('Áreas doadas'),
      valorTaxaCompensacaoReal: yup
        .number()
        .float()
        .positive()
        .nullable()
        .nanable()
        .label('Valores pagos'),
      valorInvestidoTerceirosReal: yup
        .number()
        .float()
        .positive()
        .nullable()
        .nanable()
        .label('Valores investidos'),
      valorInvestidoConvenioReal: yup
        .number()
        .float()
        .positive()
        .nullable()
        .nanable()
        .label('Valores investidos'),
      areaConvenioHa: yup
        .number()
        .nullable()
        .nanable()
        .label('Área conservada'),
      possuiInventarioEmissao: yup
        .number()
        .positive()
        .nullable()
        .label('Inventário de emissão'),
      adaptacaoClimatica: yup
        .number()
        .positive()
        .nullable()
        .label('Plano de adaptação'),
      mitigacaoPublicamenteEstabelecida: yup
        .number()
        .positive()
        .nullable()
        .label('Meta estabelecida'),
      inventarioEscopoUm: yup.number().nullable().nanable().label('Escopo 1'),
      inventarioEscopoDois: yup.number().nullable().nanable().label('Escopo 2'),
      observacoes: yup.string().nullable().label('Observações'),
      numeroDeMinas: yup.number().nullable().nanable().label('Minas'),
      numeroPlanosFechamento: yup
        .number()
        .nullable()
        .nanable()
        .label('Planos fechamento'),
      indicadorFechamentoAvaliado: yup.number().nullable().nanable().label('Indicadores avaliados'),
      indicadorFechamentoAaa: yup.number().nullable().nanable().label('Indicadores AAA'),
      indicadorFechamentoAa: yup.number().nullable().nanable().label('Indicadores AA'),
      indicadorFechamentoA: yup.number().nullable().nanable().label('Indicadores A'),
      indicadorFechamentoB: yup.number().nullable().nanable().label('Indicadores B'),
      indicadorFechamentoC: yup.number().nullable().nanable().label('Indicadores C'),
      indicadorFechamentoObservacao: yup
        .string()
        .nullable()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Relate aqui cases de boas práticas.'),
      indicadorSustentabilidadeAvaliado: yup.number().nullable().nanable().label('Indicadores avaliados'),
      indicadorSustentabilidadeAaa: yup.number().nullable().nanable().label('Indicadores AAA'),
      indicadorSustentabilidadeAa: yup.number().nullable().nanable().label('Indicadores AA'),
      indicadorSustentabilidadeA: yup.number().nullable().nanable().label('Indicadores A'),
      indicadorSustentabilidadeB: yup.number().nullable().nanable().label('Indicadores B'),
      indicadorSustentabilidadeC: yup.number().nullable().nanable().label('Indicadores C'),
      indicadorSustentabilidadeObservacao: yup
        .string()
        .nullable()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Relate aqui cases de boas práticas.'),
      colaboracaoAmbientalMesmoTerritorio: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa desenvolve trabalhos ambientais de forma colaborativa com outras mineradoras para o mesmo território.'
        )
        .default(false),
      planoDeAcaoConjunto: yup
        .boolean()
        .nullable()
        .label('Estes trabalhos possuem plano de ação conjunto.')
        .default(false),
      melhoriaDoProcesso: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa desenvolve melhoria do processo de condução dos estudos, através de: i) viabilização da discussão dos novos projetos com as diversas partes interessadas através da busca pela participação das mesmas, podendo ser por consulta pública ou outras formas e ii) discussão e, se for o caso, adequação das melhores soluções para minimização/mitigação do risco.'
        )
        .default(false),
      qualificacaoDosEstudos: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa realiza a qualificação dos estudos de alternativas e dos diagnósticos ambientais, por: i) avaliação, de forma consistente e pelo menos em nível de pré-viabilidade, das alternativas tecnológicas e locacionais, com vistas a tomadas de decisão coerentes com as condições da área de inserção; e ii) composição de diagnósticos ambientais objetivos em seu nível de detalhe e abrangência, com foco em processos e sua dinâmica, e que sejam compatíveis com as características da área na qual se inserem os novos projetos, observados dos zoneamentos socioeconômicos e ambientais existentes'
        )
        .default(false),
      melhoriaDasAvaliacoes: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa desenvolve melhoria das avaliações de impacto e da concepção das medidas diversas necessárias através de: i) análises dos riscos e impactos ambientais dos novos projetos, de preferência sob a perspectiva de uma avaliação ambiental estratégica ou de impactos cumulativos / sinérgicos utilizando as melhores práticas disponíveis; ii) comparação dos cenários “com” e “sem” a implantação do projeto (viabilidade ambiental e social) para fins de tomada de decisão, e descrição de forma justificada e objetiva das áreas de influência direta e indireta, bem como dos respectivos impactos, levando em conta os aspectos ambientais dos projetos e os itens do diagnóstico que realmente interessam na caracterização e avaliação desses impactos; e iii) concepção de medidas eficientes de controle, mitigação, recuperação, compensação, monitoramento e potencialização (estas, no caso de impactos positivos), coerentes com os diagnósticos e prognósticos ambientais, e que sejam mensuráveis através de indicadores definidos de forma objetiva'
        )
        .default(false),
      planejamentoDoProcesso: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa elabora o planejamento do processo de avaliação do atendimento às expectativas de performance estabelecidas conforme melhores práticas disponíveis e utilizando quando aplicáveis referências como a do ICMM (2020), com definição de cronograma que envolva cada uma das empresas associadas, com início do processo de validação do desempenho já a partir de 2022, por meio da avaliação tanto em nível corporativo quanto em nível das operações das empresas associadas.'
        )
        .default(false),
      validacaoDoDesempenho: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa realiza a validação do desempenho das empresas alinhado ao trabalho do TSM de acordo com os seguintes elementos:(a) Implementação do processo de avaliação de desempenho com a realização de autoavaliações completas de cada empresa uma vez a cada três anos; (b) Divulgação anual dos resultados da avaliação de desempenho nos websites das companhias, em publicação adequada e acessível.'
        )
        .default(false),
      adocaoDeMedidas: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa adota medidas de controle ambiental buscando a melhoria das técnicas no processo de mineração, em conformidade com as melhores práticas e utilizando quando aplicáveis referências como os Mining Principles do ICMM (2020) (e), especialmente com o 2º deles (“Decision-Making”), e os “Padrões de Desempenho sobre Sustentabilidade Socioambiental” do IFC (2012).'
        )
        .default(false),
      integracaoDoConceito: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa aplica a integração do conceito de desenvolvimento sustentável, à maneira do “Enduring Value” do Mining Council of Australia (MCA, 2015), com integração dos princípios de desenvolvimento sustentável às políticas, planos e projetos das empresas associadas, de modo que a abordagem destas quanto ao tema seja transparente e consistentemente implementada.'
        )
        .default(false),
      adocaoDasMelhoresPraticas: yup
        .boolean()
        .nullable()
        .label(
          'A minha empresa adota das melhores práticas e utilizando quando aplicáveis referências como Mining Principles do ICMM(2020)(e) - especialmente do “4. Risk Management”, do “6. Environmental Performance”, do “7. Conservation of Biodiversity, e do “8. Responsible Production”), dos Position Statements do mesmo ICMM(h) e do padrão do CSBI(j) e ICMBIO(k), viabilizando: i) a implementação de controles baseados no risco, para evitar, minimizar e/ou remediar impactos; ii) a aplicação da abordagem de hierarquia de mitigação para evitar poluição e gerenciar efluentes e resíduos em geral; iii) a implementação de medidas para melhorar a eficiência energética e contribuir para um futuro de baixo carbono; iv) o não desenvolvimento de novos empreendimentos em áreas de Patrimônio Mundial, respeitando áreas legalmente protegidas e concebendo projetos e operações de forma compatível com o valor dessas áreas; v) a avaliação dos riscos e impactos à biodiversidade e aos serviços ecossistêmicos, considerando a metodologia de hierarquia de mitigação; e vi) a implementação de medidas viáveis para recuperação, reuso e/ou reciclagem de energia, recursos naturais e/ou materiais."'
        )
        .default(false),
      observacoesBiodiversidade: yup
        .string()
        .nullable()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Relate aqui cases de boas práticas.'),
      observacoesMudancasClimaticas: yup
        .string()
        .nullable()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Relate aqui cases de boas práticas.'),
      observacoesFechamentoMina: yup
        .string()
        .nullable()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Relate aqui cases de boas práticas.'),
      observacoesMesmaRegiao: yup
        .string()
        .nullable()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Relate aqui cases de boas práticas.'),
      observacoesImpactoAmbiental: yup
        .string()
        .nullable()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Relate aqui cases de boas práticas.'),
      observacoesControleAmbiental: yup
        .string()
        .nullable()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Relate aqui cases de boas práticas.')
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    reset,
    watch,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const onSave = async data => {
    startLoading();

    let result;
    try {
      console.log(data);
      if (data.id) {
        result = await api.http.put(
          `/04/mitigacao-impactos-ambientais/empresa/${watchEmpresaId}/${data.id}`,
          {
            ...data,
            ano
          }
        );
      } else {
        result = await api.http.post(
          `/04/mitigacao-impactos-ambientais/empresa/${watchEmpresaId}`,
          {
            ...data,
            ano: ano
          }
        );
      }
      reset(result.data);
      stopLoading({ severity: 'success' });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  const loadDadosGerais = async mount => {
    startLoading();
    try {
      let getDadosGerais = await api.http.get(
        `/04/mitigacao-impactos-ambientais/empresa/${watchEmpresaId}/${ano}`
      );
      if (mount.isMounted) reset(getDadosGerais.data);
      stopLoading();
    } catch (error) {
      if (error.response && error.response.status === 404) {
        if (mount.isMounted) {
          reset({
            areaDoacaoEstadoHa: '',
            valorTaxaCompensacaoReal: '',
            valorInvestidoTerceirosReal: '',
            valorInvestidoConvenioReal: '',
            areaConvenioHa: '',
            possuiInventarioEmissao: null,
            inventarioEscopoUm: '',
            inventarioEscopoDois: '',
            observacoes: '',
            numeroDeMinas: '',
            numeroPlanosFechamento: '',
            indicadorFechamentoAvaliado: '',
            indicadorFechamentoAaa: '',
            indicadorFechamentoAa: '',
            indicadorFechamentoA: '',
            indicadorFechamentoB: '',
            indicadorFechamentoC: '',
            indicadorFechamentoObservacao: '',
            indicadorSustentabilidadeAvaliado: '',
            indicadorSustentabilidadeAaa: '',
            indicadorSustentabilidadeAa: '',
            indicadorSustentabilidadeA: '',
            indicadorSustentabilidadeB: '',
            indicadorSustentabilidadeC: '',
            indicadorSustentabilidadeObservacao: '',
            colaboracaoAmbientalMesmoTerritorio: null,
            planoDeAcaoConjunto: null,
            observacoesControleAmbiental: '',
            melhoriaDoProcesso: null,
            qualificacaoDosEstudos: null,
            melhoriaDasAvaliacoes: null,
            planejamentoDoProcesso: null,
            validacaoDoDesempenho: null,
            adocaoDeMedidas: null,
            integracaoDoConceito: null,
            adocaoDasMelhoresPraticas: null
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadDadosGerais(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [watchEmpresaId, ano]);

  //Areas protegidas e impactadas
  const loadAreasProtegidasEImpactadas = async mount => {
    startLoading();
    try {
      let getRows = (
        await api.http.get(
          `/04/areas-protegidas-e-impactadas/empresa/${watchEmpresaId}/${ano}`
        )
      ).data;
      if (!mount || mount.isMounted) setRows(getRows);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };
  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    if (watchEmpresaId) loadAreasProtegidasEImpactadas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [ano, watchEmpresaId]);

  const onRowClick = (params, event, details) => {
    setDadosAreas(params.row);
    setOpenDialogo(true);
  };

  const onCloseDialogo = (reload = false) => {
    setDadosAreas(null);
    setOpenDialogo(false);
    if (reload) {
      loadAreasProtegidasEImpactadas();
    }
  };

  const deleteDados = row => async () => {
    startLoading();
    try {
      await api.http.delete(
        `/04/areas-protegidas-e-impactadas/empresa/${row.empresaId}/${row.id}`
      );
      stopLoading({ severity: 'success' });
      let mount = {
        isMounted: true
      };
      loadAreasProtegidasEImpactadas(mount);
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const columns = React.useMemo(
    () => [
      {
        field: 'unidadeFederativa',
        headerName: 'Unidade Federativa',
        flex: 1,
        valueGetter: (value) => estadosObj[value],
      },
      {
        field: 'areasProtegidas',
        headerName: 'Áreas Protegidas',
        flex: 1
      },
      {
        field: 'areasRegularizadas',
        headerName: 'Áreas Regularizadas',
        flex: 1
      },
      {
        field: 'areasConvenio',
        headerName: 'Áreas via Convênio',
        flex: 1
      },
      {
        field: 'areasImpactadas',
        headerName: 'Áreas Impactadas',
        flex: 1
      },
      {
        field: 'fonteDaInformacao',
        headerName: 'Fonte',
        flex: 1
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Remover',
        width: 100,
        getActions: params => [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={deleteDados(params.row)}
          />
        ]
      }
    ],
    [deleteDados]
  );

  const novoRegistro = async () => {
    setOpenDialogo(true);
  };

  return (
    (<div>
      <Divider>
        <h3>Biodiversidade</h3>
      </Divider>
      <Grid
        container
        spacing={2}
        sx={{
          '& .MuiTypography-root': { textAlign: 'right' },
          '& .MuiGrid-root': { p: 1 },
          '& .MuiSvgIcon-root': { verticalAlign: 'middle' }
        }}
      >
        <Grid
          size={{
            md: 12
          }}></Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Áreas doadas para o Estado para fins de compensação (em ha):
            <HelpOutlineIcon
              onClick={handleFirstClick}
              sx={{
                m: 2
              }}
            />
          </Typography>
          <Popover
            open={Boolean(firstPopoverAnchor)}
            anchorEl={firstPopoverAnchor}
            onClose={handleCloseFirstClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              As áreas cedidas (mesmo que provisoriamente), doadas ou as que
              tiveram a propriedade transferida para o órgão ambiental (para
              fins de compensação ambiental)
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="areaDoacaoEstadoHa"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Valores pagos como taxa de compensação (em R$):
            <HelpOutlineIcon
              onClick={handleSecondClick}
              sx={{
                m: 2
              }}
            />
          </Typography>
          <Popover
            open={Boolean(secondPopoverAnchor)}
            anchorEl={secondPopoverAnchor}
            onClose={handleCloseSecondClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Quantitativo histórico das áreas doadas ao Estado,no ano de
              referência, para fins de compensação minerária, ambiental e/ou
              para fins de regularização fundiária. Deve-se deixar claro que a
              responsabilidade de proteção ambiental dessas áreas doadas passa a
              ser de responsabilidade do Estado. Também deve estar clara a
              informação que essa doação tem natureza mandatória, ou seja,
              trata-se de cumprimento de requisito legal, porém, acreditamos que
              a iniciativa tem valor para a proteção e conservação da
              biodiversidade e para a manutenção dos serviços ambientais. Neste
              contexto destaca-se gastos associados ao cumprimento das
              diretrizes previstas nos artigos 17 e 32 da Lei da Mata Atlântica
              (Lei Federal nº 11.428/2006), relativos às atividades de proteção
              ecossistêmica para conservação da vegetação nativa ou recomposição
              da vegetação natural em terrenos próprios ou de terceiros.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <FloatField
              field="valorTaxaCompensacaoReal"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Valores investidos em regularização fundiária de terceiros (em R$):
            <HelpOutlineIcon
              onClick={handleTenthClick}
              sx={{
                m: 2
              }}
            />
          </Typography>
          <Popover
            open={Boolean(tenthPopoverAnchor)}
            anchorEl={tenthPopoverAnchor}
            onClose={handleCloseTenthClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Justificativa: permitir que os valores que as empresas investem em
              regularização fundiária de terceiros para viabilizar doações para áreas
              de conservação sejam transformadas em unidades de conservação.”
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <FloatField
              field="valorInvestidoTerceirosReal"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography m={2}>
            Valores investidos em convênios de manejo de áreas de conservação (em R$):
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <FloatField
              field="valorInvestidoConvenioReal"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Área proporcional conservada via convênios (em ha):
            <HelpOutlineIcon
              onClick={handleEleventhClick}
              sx={{
                m: 2
              }}
            />
          </Typography>
          <Popover
            open={Boolean(eleventhPopoverAnchor)}
            anchorEl={eleventhPopoverAnchor}
            onClose={handleCloseEleventhClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Justificativa: mostrar quais valores e áreas são conservadas através
              de planos de manejo parcialmente financiados pelos recursos da mineração.
              Neste caso, para o cálculo da área proporcional, a recomendação é que seria
              a área total da Unidade de Conservação dividida pelo Orçamento Estimado total
              para manejo da área multiplicado pelo valor investido pela mineradora via convênio.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="areaConvenioHa"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>
      <p>Observações:</p>
      <FormControl fullWidth>
        <TextField
          field="observacoesBiodiversidade"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Divider>
        <h3>Áreas Protegidas/Impactadas</h3>
      </Divider>
      <DialogoAreasProtegidasEImpactadas
        watchEmpresaId={watchEmpresaId}
        ano={ano}
        dadosAreas={dadosAreas}
        open={openDialogo}
        onClose={onCloseDialogo}
      />
      <Box>
        <Stack direction="column" sx={{ textAlign: 'left', mb: 3 }}>
          <DialogContentText>
            Áreas Protegidas: Área geograficamente definida que é designada,
            regulada ou gerida para lograr objetivos específicos de preservação,
            incluindo as APPs e Reservas Legais.
          </DialogContentText>
          <br></br>
          <DialogContentText>
            Áreas Impactadas: Área geográfica onde se localizam as estruturas
            minerárias e de apoio, incluindo as vias de acesso interno e as
            estruturas de logística e que sofreram alterações físicas e
            biológicas decorrentes da implantação e operação do empreendimento.
          </DialogContentText>
        </Stack>
        <Grid container spacing={3} sx={{ my: 2 }}>
          <Grid style={{ textAlign: 'right' }} size="grow">
            <Button color="primary" variant="outlined" onClick={novoRegistro}>
              Novo Registro de Áreas Protegidas/Impactadas
            </Button>
          </Grid>
        </Grid>
        <Paper
          variant="elevation"
          elevation={2}
          sx={{
            mb: 5
          }}
          style={{
            height: 400,
            width: '100%'
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            onRowClick={onRowClick}
            slots={{ noRowsOverlay: NoRowsOverlay }}
            disableSelectionOnClick
          />
        </Paper>
      </Box>
      <Divider sx={{ mt: 3 }}>
        <h3>Mudanças climáticas</h3>
      </Divider>
      <Grid
        container
        spacing={2}
        sx={{
          '& .MuiTypography-root': { textAlign: 'right' },
          '& .MuiGrid-root': { p: 1 },
          '& .MuiSvgIcon-root': { verticalAlign: 'middle' }
        }}
      >
        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
            Possui inventário de emissão absoluta neste ano de referência?
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <Select
              field="possuiInventarioEmissao"
              options={opcoesBooleanas}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Inventário de emissão absoluta (tCO2e) - Escopo 1:
            <HelpOutlineIcon
              onClick={handleThirdClick}
              sx={{
                m: 2
              }}
            />
          </Typography>
          <Popover
            open={Boolean(thirdPopoverAnchor)}
            anchorEl={thirdPopoverAnchor}
            onClose={handleCloseThirdClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
            Escopo 1: Emissões diretas de GEE provenientes de fontes que pertencem ou são controladas pela 
            organização inventariante. Obs.: o transporte entre a unidade de beneficiamento físico e a 
            unidade de beneficiamento químico (exemplo: pelotização) está contemplada no escopo 1 
            (fonte: Inventário De Emissões De Gases De Efeito Estufa Do Setor Mineral 2024 (Ano Base 2022))
              <Typography component="div" sx={{ textAlign: "center", mt: 1 }}>
                <Link 
                  href="https://venidera.sharepoint.com/:b:/s/IBRAM/EX-60zjTLJJDvXsrAAKFxwcBVSsZWJuhUXCGI7e_fvPlFg?e=OYWSXV"
                  target="_blank" 
                  rel="noopener noreferrer"
                > 
                  Saiba mais
                </Link>
              </Typography>
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="inventarioEscopoUm"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Inventário de emissão absoluta (tCO2e) - Escopo 2:
            <HelpOutlineIcon
              onClick={handleFourthClick}
              sx={{
                m: 2
              }}
            />
          </Typography>
          <Popover
            open={Boolean(fourthPopoverAnchor)}
            anchorEl={fourthPopoverAnchor}
            onClose={handleCloseFourthClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
            Escopo 2: Emissões indiretas de GEE provenientes da aquisição de energia elétrica que é 
            consumida pela organização inventariante. (fonte: Inventário De Emissões De Gases De Efeito 
            Estufa Do Setor Mineral 2024 (Ano Base 2022))
              <Typography component="div" sx={{ textAlign: "center", mt: 1 }}>
                <Link 
                  href="https://venidera.sharepoint.com/:b:/s/IBRAM/EX-60zjTLJJDvXsrAAKFxwcBVSsZWJuhUXCGI7e_fvPlFg?e=OYWSXV"
                  target="_blank" 
                  rel="noopener noreferrer"
                > 
                  Saiba mais
                </Link>
              </Typography>
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="inventarioEscopoDois"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
            A empresa possui plano de adaptação climática?
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <Select
              field="adaptacaoClimatica"
              options={opcoesBooleanas}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
            A empresa possui plano de mitigação com meta publicamente
            estabelecida?
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <Select
              field="mitigacaoPublicamenteEstabelecida"
              options={opcoesBooleanas}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>
      <p>Observações:</p>
      <FormControl fullWidth>
        <TextField
          field="observacoesMudancasClimaticas"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Divider sx={{ mt: 3 }}>
        <h3>Fechamento de Mina</h3>
      </Divider>
      <DialogContentText sx={{ mb: 4 }}>
        Todas as unidades em implantação, operação, suspensão temporária,
        encerradas, no ano de referência devem ser consideradas nesse report de
        dados.
      </DialogContentText>
      <Grid
        container
        spacing={2}
        sx={{
          '& .MuiTypography-root': { textAlign: 'right' },
          '& .MuiGrid-root': { p: 1 },
          '& .MuiSvgIcon-root': { verticalAlign: 'middle' }
        }}
      >
        <Grid
          size={{
            md: 12
          }}></Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Número de minas:
            <HelpOutlineIcon
              onClick={handleFifthClick}
              sx={{
                m: 2
              }}
            />
          </Typography>
          <Popover
            open={Boolean(fifthPopoverAnchor)}
            anchorEl={fifthPopoverAnchor}
            onClose={handleCloseFifthClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Em implantação, operação, suspensão temporária, encerradas, etc.
              no ano de referência.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="numeroDeMinas"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 9
          }}>
          <Typography>
            Número de planos de fechamento:
            <HelpOutlineIcon
              onClick={handleSixthClick}
              sx={{
                m: 2
              }}
            />
          </Typography>
          <Popover
            open={Boolean(sixthPopoverAnchor)}
            anchorEl={sixthPopoverAnchor}
            onClose={handleCloseSixthClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Demonstrar o número de operações com Planos de Fechamento,
              contemplando as questões ambientais e socioeconômicas e com as
              diretrizes para participação social.* Ao operar e fechar uma mina
              em conformidade com as melhores práticas, a empresa demonstra a
              capacidade de responder adequadamente às demandas de proteção
              ambiental e responsabilidade social, contribuindo para a
              sustentabilidade.O plano de fechamento é um documento que registra
              os resultados do planejamento, estabelecendo os objetivos de
              fechamento e descrevendo as medidas a serem tomadas para
              atingi-los, de forma a orientar a empresa e outros agentes
              envolvidos. Neste contexto, a existência do plano de fechamento e
              a sua abordagem multidisciplinar, com visão social,que vai além do
              cumprimento regulatório é o objetivo desse indicador.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="numeroPlanosFechamento"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>
      <p>Observações:</p>
      <FormControl fullWidth>
        <TextField
          field="observacoesFechamentoMina"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Stack direction="row" sx={{ alignItems: 'center', mt: 3, justifyContent: 'center' }}>
          <strong>Aderência às boas práticas de fechamento de mina</strong>
          <HelpOutlineIcon
            onClick={handleTwelfthClick}
            sx={{
              mx: 2
            }}
          />
          <Popover
            open={Boolean(twelfthPopoverAnchor)}
            anchorEl={twelfthPopoverAnchor}
            onClose={handleCloseTwelfthClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Visa verificar o grau de aderência da mineradora em relação às boas
              práticas de fechamento de mina, por meio do atendimento aos 38 indicadores
              de desempenho apresentados no Guia de Indicadores para Fechamento de Mina (IBRAM, 2024).
            </Typography>
          </Popover>
        </Stack>
      <Grid
        container
        spacing={2}
        sx={{
          mt: 1,
          '& .MuiTypography-root': { textAlign: 'right' },
          '& .MuiGrid-root': { p: 1 },
          '& .MuiSvgIcon-root': { verticalAlign: 'middle' }
        }}
      >
        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
            Número de indicadores avaliados
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorFechamentoAvaliado"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
            Número de indicadores com desempenho AAA
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorFechamentoAaa"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
          Número de indicadores com desempenho AA
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorFechamentoAa"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
          Número de indicadores com desempenho A
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorFechamentoA"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
          Número de indicadores com desempenho B
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorFechamentoB"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
          Número de indicadores com desempenho C
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorFechamentoC"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>
      <p>Observações:</p>
      <FormControl fullWidth>
        <TextField
          field="indicadorFechamentoObservacao"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Stack direction="row" sx={{ alignItems: 'center', mt: 3, justifyContent: 'center' }}>
          <strong>Aderência às boas práticas de sustentabilidade para fechamento de mina</strong>
          <HelpOutlineIcon
            onClick={handleThirteenthClick}
            sx={{
              mx: 2
            }}
          />
          <Popover
            open={Boolean(thirteenthPopoverAnchor)}
            anchorEl={thirteenthPopoverAnchor}
            onClose={handleCloseThirteenthClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Visa verificar o grau de aderência da mineradora em relação às boas práticas
              de sustentabilidade para fechamento de mina, por meio do atendimento aos 6 indicadores
              de desempenho apresentados no Guia de Critérios de Sustentabilidade para Fechamento de Mina (IBRAM, 2024).
            </Typography>
          </Popover>
        </Stack>
      <Grid
        container
        spacing={2}
        sx={{
          mt: 1,
          '& .MuiTypography-root': { textAlign: 'right' },
          '& .MuiGrid-root': { p: 1 },
          '& .MuiSvgIcon-root': { verticalAlign: 'middle' }
        }}
      >
        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
            Número de indicadores avaliados
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorSustentabilidadeAvaliado"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
            Número de indicadores com desempenho AAA
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorSustentabilidadeAaa"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
          Número de indicadores com desempenho AA
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorSustentabilidadeAa"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
          Número de indicadores com desempenho A
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorSustentabilidadeA"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
          Número de indicadores com desempenho B
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorSustentabilidadeB"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>

        <Grid
          size={{
            md: 9
          }}>
          <Typography sx={{ p: 2 }}>
          Número de indicadores com desempenho C
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 3
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="indicadorSustentabilidadeC"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>
      <p>Observações:</p>
      <FormControl fullWidth>
        <TextField
          field="indicadorSustentabilidadeObservacao"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Divider sx={{ mt: 3 }}>
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          <h3>Integração das empresas que operam na mesma região</h3>
          <HelpOutlineIcon
            onClick={handleSeventhClick}
            sx={{
              mx: 2
            }}
          />
          <Popover
            open={Boolean(seventhPopoverAnchor)}
            anchorEl={seventhPopoverAnchor}
            onClose={handleCloseSeventhClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Você deve marcar todas as opções aplicáveis a sua empresa.
            </Typography>
          </Popover>
        </Stack>
      </Divider>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl>
          <Checkbox
            field="colaboracaoAmbientalMesmoTerritorio"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <Stack direction="row">
        <Checkbox
          field="planoDeAcaoConjunto"
          schema={schema}
          useFormRef={useFormRef}
        />
      </Stack>
      <p>Observações:</p>
      <FormControl fullWidth>
        <TextField
          field="observacoesMesmaRegiao"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Divider sx={{ mt: 3 }}>
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          <h3>Estudos de impacto ambiental</h3>
          <HelpOutlineIcon
            onClick={handleEighthClick}
            sx={{
              mx: 2
            }}
          />
          <Popover
            open={Boolean(eighthPopoverAnchor)}
            anchorEl={eighthPopoverAnchor}
            onClose={handleCloseEighthClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Você deve marcar todas as opções aplicáveis a sua empresa. É possível escolher mais de uma opção.
            </Typography>
          </Popover>
        </Stack>
      </Divider>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl>
          <Checkbox
            field="melhoriaDoProcesso"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl>
          <Checkbox
            field="qualificacaoDosEstudos"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl>
          <Checkbox
            field="melhoriaDasAvaliacoes"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <p>Observações:</p>
      <FormControl fullWidth>
        <TextField
          field="observacoesImpactoAmbiental"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Divider sx={{ mt: 3 }}>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center'
          }}
        >
          <h3>Controles ambientais</h3>
          <HelpOutlineIcon
            onClick={handleNinthClick}
            sx={{
              mx: 2
            }}
          />
          <Popover
            open={Boolean(ninthPopoverAnchor)}
            anchorEl={ninthPopoverAnchor}
            onClose={handleCloseNinthClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Typography sx={{ p: 2 }}>
              Você deve marcar todas as opções aplicáveis a sua empresa. É possível escolher mais de uma opção.
            </Typography>
          </Popover>
        </Stack>
      </Divider>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl fullWidth>
          <Checkbox
            field="planejamentoDoProcesso"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl fullWidth>
          <Checkbox
            field="validacaoDoDesempenho"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl fullWidth>
          <Checkbox
            field="adocaoDeMedidas"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl fullWidth>
          <Checkbox
            field="integracaoDoConceito"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'left', mb: 3 }}>
        <FormControl fullWidth>
          <Checkbox
            field="adocaoDasMelhoresPraticas"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <p>Observações:</p>
      <FormControl fullWidth>
        <TextField
          field="observacoesControleAmbiental"
          fullWidth
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Button
        variant="outlined"
        sx={{ mr: 2 }}
        onClick={() => {
          reset();
        }}
        disabled={!isDirty || isSubmitting}
      >
        CANCELAR
      </Button>
      <Button
        sx={{ my: 2 }}
        variant="contained"
        onClick={handleSubmit(onSave)}
        disabled={!isDirty || isSubmitting}
      >
        Salvar
      </Button>
    </div>)
  );
};

export default DadosGerais;
